module.exports = __webpack_public_path__ + "static/media/dummy.6beb6986.png";